
import { Component, Vue } from 'vue-property-decorator'
import Search from '@/components/search.vue'
import { openGlobalCustomerService } from '@/utils/global-customer-service'
@Component({
    name: 'globalHeader',
    components: {
        Search
    }
})
export default class extends Vue {
    private isScroll = false
    private handleScroll () {
        let scrollTop = document.documentElement.scrollTop
        this.isScroll = scrollTop > 0
    }
	mounted () {
    	window.addEventListener('scroll', this.handleScroll)
    } 
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
    private toTop() {
        let top = document.documentElement.scrollTop
        const speed = document.documentElement.scrollTop / 30
        const timer = setInterval(() => {
            document.documentElement.scrollTop = top -= speed
            if(top <= 0) {
                clearInterval(timer)
            }
        }, 10)
        this.handleScroll()
    }
    // 问题反馈
    private questionFeedback() {
        this.$jump('/feedback')
    }
    private openGlobalCustomerService() {
        openGlobalCustomerService()
    }
}

